import { useNotify, useRefresh, useUnselectAll } from "react-admin";

import { firestore } from "../../../init/firebase";
import { AppResource } from "../../../types/resource.types";
import { applyUpdateTimestamp } from "../../../utils/timestamp";

export const useUpdatePlaceStatus = () => {
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const placesQuery = (placeId: string) => firestore.collection(AppResource.places).doc(placeId);

  return async (selectedIds: string[], status: boolean) => {
    try {
      const batch = firestore.batch();
      selectedIds.forEach((id: string) => {
        batch.update(
          placesQuery(id),
          applyUpdateTimestamp({
            disabled: status,
          })
        );
      });
      await batch.commit();

      notify(`Places have been ${!status ? "enabled" : "disabled"}`, "success");
      unselectAll(AppResource.places);
      refresh();
    } catch (ex: any) {
      console.log(ex.message);
      notify(`Error on ${!status ? "enabling" : "disabling"} place`, "error");
    }
  };
};
